//封装axios
import Vue from 'vue'
import axios from 'axios';
import qs from 'qs'
import router from '../router';
import { Notify } from 'vant'
import store from '../store/index';
import VueLocalStorage from 'vue-localstorage'
import ApiSetting from '@/request/api/setting'
Vue.use(Notify)
Vue.use(VueLocalStorage)

// let vueobj = new Vue();

// const toSignin = function () {
//   // store.dispatch("clearUserInfo");
//
//   // var message = msg ? msg : "session过期，即将前往登录页面";
//   // vueobj.$message.error({showClose: true, message: message, duration: 3000, onClose: function () {
//   //     router.replace({path: '/signin', query: {redirect: router.currentRoute.fullPath}
//   //     });
//   // }});
//   router.replace(
//     {
//       path: '/signin',
//       query: {redirect: router.currentRoute.fullPath}
//     }
//   )
// }
const toAuthWechat = function () {
  // window.console.log("toAuthWechat")
  // store.commit('setRedirect', router.currentRoute.fullPath)
  Vue.localStorage.set('redirect', router.currentRoute.fullPath)
  router.replace({path: '/auth/wechat'})
}
/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 400:
      // vueobj.$message.error({showClose: true, message: "请求参数有误！", duration: 3000});
      Notify({ type: 'danger', message: '请求参数不正确' })
      break;
    // 401: 未登录状态，跳转登录页
    case 401:
      //vueobj.$message.error({showClose: true, message: "session过期，即将前往登录页面！", duration: 3000});
      // Notify({ type: 'danger', message: '认证失败' })
      // toSignin();
      if (store.state.auth.processing == false) {
        store.commit('authProcessing', true)
        toAuthWechat()
      } else {
        // window.console.log("store.state.auth.processing == true")
        // window.console.log(store.state.auth.processing)
      }
      break;
    // 403 token过期
    // 清除token并跳转登录页
    case 403:
      // vueobj.$message.error({showClose: true, message: "没有操作权限！", duration: 3000});
      Notify({ type: 'danger', message: '操作被禁止' })
      break;
    // 404请求不存在
    case 404:
      // vueobj.$message.error({showClose: true, message: "请求不存在", duration: 3000});
      Notify({ type: 'danger', message: '资源没有找到' })
      break;
    case 500:
      // vueobj.$message.error({showClose: true, message: "请求失败，服务器内部错误", duration: 3000});
      // Notify({ type: 'danger', message: '服务器出错' })
      break;
    case 504:
      // vueobj.$message.error({showClose: true, message: "与服务器连接失败！", duration: 3000});
      Notify({ type: 'danger', message: '服务器连接失败' })
      break;
    default:
      // window.console.log(other);
      Notify({ type: 'danger', message: `出现错误：${other}` })
      break;
  }}


// 创建axios实例
var instance = axios.create({ timeout: 1000 * 12});

// post 请求头
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // const token = store.state.auth.token
    let token = null
    if (store.state.auth.token) {
      token = store.state.auth.token
    } else {
      token = Vue.localStorage.get('token', null)
    }
    // window.console.log(`TOKEN: ${token}`)
    // const expire = store.state.auth.expire
    let expire = null
    if (store.state.auth.expire) {
      expire = store.state.auth.expire
    } else {
      expire = Vue.localStorage.get('expire', null)
    }
    // window.console.log(`EXPIRE: ${expire}`)
    // window.console.log(`NOWIRE: ${new Date().getTime()}`)
    if (token != 'null' && token != null && expire != null) {
      // window.console.log("有token和过期时间")
      // window.console.log(token)
      // window.console.log(expire)
      const now = new Date().getTime()
      // window.console.log(`Exp: ${new Date(expire)}`)
      // window.console.log(`Now: ${new Date(now)}`)
      // window.console.log(`token: ${token}`)
      // window.console.log(`timestamp: ${expire}`)
      // window.console.log(`now: ${now}`)
      let processing = store.state.auth.processing
      if (now >= expire && processing == false) {
        // window.console.log("token即将过期，需要刷新")
        store.commit('authProcessing', true)
        axios.post(
          `${ApiSetting.baseUrl}/api-token-refresh/`,
          qs.stringify({'token': token})
        ).then((response) => {
          // window.console.log('刷新token成功')
          // window.console.log(response)
          store.commit(
            'tokenRefreshed',
            {
              token: response.data.token,
              expire: new Date().getTime() + 1800 * 1000 * 5, // 50分钟后过期（实际过期时间60分钟，10分钟缓冲）- 暂时改为 5 倍
              // expire: new Date().getTime() + 1 * 10 * 1000,
              processing: false
            })
          // 存入LocalStorage
          Vue.localStorage.set('token', response.data.token)
          Vue.localStorage.set(
            'expire', new Date().getTime() + 1800 * 1000 * 5)
          // Vue.localStorage.set(
          //   'expire', new Date().getTime() + 1 * 10 * 1000)

          config.headers.Authorization = 'JWT ' + token
          store.commit('authProcessing', false)
          location.reload()
        }).catch (error => {
          window.console.log('刷新token失败')
          window.console.log(error)
          store.commit('tokenClear')
          store.commit('authProcessing', false)
          // 清理LocalStorage中的token和expire
          // Vue.localStorage.removeItem('token')
          // Vue.localStorage.removeItem('expire')
          Vue.localStorage.remove('token')
          Vue.localStorage.remove('expire')
          // 新添加的处理逻辑
          if (store.state.auth.processing == false) {
            store.commit('authProcessing', true)
            toAuthWechat()
          }
          // return config
        })
      } else { // 有 token 且未过期
        // window.console.log("token未过期")
        if (token != 'null') {
          config.headers.Authorization = 'JWT ' + token
        }
        let url = config.url
        // window.console.log("请求的URL是：")
        // window.console.log(url)
        let checkToken = '/libs/wechat/check-access-token/'
        let updateInfo = '/libs/wechat/update-user-info/'
        if (url == checkToken || url == updateInfo) {
          config.headers.Authorization = ''
        }
      }
    }
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // https://www.django-rest-framework.org/api-guide/status-codes/#successful-2xx
    let codes = [200, 201, 202, 203, 204, 205, 206, 207, 208, 226]
    if (codes.indexOf(response.status) != -1) {
      if(typeof response.data != 'undefined'){
        return Promise.resolve(response);
      }else{
        return Promise.reject(response);
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {

    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);

    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      //store.commit('changeNetwork', false);
      //toSignin();
      //vueobj.$message.error({showClose: true, message: "与服务器连接失败！", duration: 3000});

      var originalRequest = error.config;
      if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){
        // originalRequest._retry = true
        // return axios.request(originalRequest);
        // vueobj.$message.error({showClose: true, message: "请求超时，请稍后重试！", duration: 3000});
        Notify({ type: 'danger', message: '请求超时，请稍后再试' })
        return Promise.reject(response);
      }else{
        Notify({ type: 'danger', message: '连接错误' })
      }
    }
  }
);

export default instance;
